import { setDatadogUser } from "utils/helper/datadog";

interface Store {
  getState: () => {
    reducers: {
      auth: {
        saved: {
          user: {
            userId: string;
          };
        };
      };
    };
  };
  subscribe: (listener: () => void) => () => void;
}

// userId はログイン時の dispatch だけでなく redux-persist の rehydrate でも
// 入るため、dispatch 箇所ではなく store の購読で拾う
export default function setupDatadogUserSync(store: Store): () => void {
  let lastUserId = "";

  const sync = (): void => {
    const { userId } = store.getState().reducers.auth.saved.user;
    if (userId === lastUserId) return;

    lastUserId = userId;
    setDatadogUser(userId);
  };

  sync();

  return store.subscribe(sync);
}
